export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.27-1445.10",
  commitId: "bb625d5d23a2fabf5fbaa2157d2e4d265330fed4",
  commitTime: "2026-07-27T14:45:10.000Z",
});
